// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"e474e62a","729":"6fd55222"}[chunkId] + ".chunk.js";
};